import { useState } from 'react';
import { Tooltip, assets } from '@round/whitelabel-ui';
import { UnderLineTabs } from '@round/whitelabel-ui';
import { TabPanel, TabPanels } from '@round/whitelabel-ui';
import styles from './SongFormAudios.module.css';
import { Label } from '@round/whitelabel-ui';
import PlatformIcon from 'Modules/Plans/components/PlatformIcon';
import SongFormTiktokAudios from './TiktokAudios/SongFormTiktokAudios';
import SongFormInstagramAudios from './InstagramAudios/SongFormInstagramAudios';
import ChangedAudios from './components/ChangedAudios';

const { InfoCircle: InfoIcon } = assets;

type Props = {
    staticTiktokAudios?: number[];
    staticInstagramAudios?: number[];
};

const SongFormAudios = ({ staticTiktokAudios, staticInstagramAudios }: Props) => {
    const [audioPlatformMode, setAudioPlatformMode] = useState<'tiktok' | 'instagram'>('tiktok');
    const [audiosTooltipAnchor, setAudiosTooltipAnchor] = useState<SVGSVGElement | null>(null);

    return (
        <section className={styles.container}>
            <Label className={styles.audiosLabel}>
                <span>Add audios</span>
                <InfoIcon ref={setAudiosTooltipAnchor} className={styles.infoCircle} />
                <Tooltip anchorElement={audiosTooltipAnchor}>
                    <Tooltip.Body>
                        Link audios to the song and we'll gather data on them.
                        <br />
                        For released songs, we'll automatically link audios we find.
                    </Tooltip.Body>
                </Tooltip>
            </Label>

            <UnderLineTabs activeTab={audioPlatformMode} onChange={(tab) => setAudioPlatformMode(tab)}>
                <UnderLineTabs.Menu>
                    <UnderLineTabs.Item name="tiktok">
                        <PlatformIcon
                            platform="tiktok"
                            colored={audioPlatformMode === 'tiktok'}
                            className={styles.platformIcon}
                        />
                        <span>TikTok</span>
                    </UnderLineTabs.Item>
                    <UnderLineTabs.Item name="instagram">
                        <PlatformIcon
                            platform="instagram"
                            colored={audioPlatformMode === 'instagram'}
                            className={styles.platformIcon}
                        />
                        <span>Instagram</span>
                    </UnderLineTabs.Item>
                </UnderLineTabs.Menu>

                <TabPanels>
                    <TabPanel name="tiktok">
                        <SongFormTiktokAudios staticTiktokAudios={staticTiktokAudios || []} />
                    </TabPanel>
                    <TabPanel name="instagram">
                        <SongFormInstagramAudios staticInstagramAudios={staticInstagramAudios || []} />
                    </TabPanel>
                </TabPanels>
            </UnderLineTabs>
            <ChangedAudios />
        </section>
    );
};

export default SongFormAudios;
